<div class="main__toolbar-wrapper" ngClass.lt-md="medium-breakpoint">
  <mat-toolbar class="main__toolbar">
    <a [routerLink]="['/dashboard']" class="main__logo-link" ><img src="/assets/images/logo-header.svg"/></a>
  </mat-toolbar>
</div>

<div class="content">
  <p class="large">Logging in...</p>
  <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
</div>
